<template>
  <!-- 排序 -->
  <el-button-group style="float:right;margin: 20px 0;">
    <el-button
      v-for="(op, index) in sortOptions.options"
      :key="index"
      @click="sortBy(op)"
      class="sort-button"
      :class="{ active: sortOptions.curField === op.field }"
    >
      {{ $t(op.label) }}
      <i
        v-if="sortOptions.curField === op.field"
        class="el-icon-caret-bottom"
        :class="{ desc: op.order === 'asc' }"
      ></i>
    </el-button>
  </el-button-group>
</template>
<script>
export default {
  props: {
    sortOptions: {
      type: Object,
      default: function() {
        return {
          curField: "bookingTime",
          options: [
            {
              field: "bookingTime",
              label: "ffm_booking_time",
              order: "desc"
            },
            {
              field: "travelDate",
              label: "ffm_travel_date",
              order: "desc"
            }
          ]
        };
      }
    }
  },
  methods: {
    // 排序
    sortBy(op) {
      if (this.sortOptions.curField === op.field) {
        op.order = op.order === "asc" ? "desc" : "asc";
      }
      this.sortOptions.curField = op.field;
      this.$emit("sort", {
        curField: this.sortOptions.curField,
        curOrder: this.sortOptions.options.find(
          v => v.field === this.sortOptions.curField
        ).order
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sort-button {
  position: relative;
  padding-right: 34px;
  width: 150px;
  &.active {
    color: #1079fb;
    border-color: #1079fb;
    transition: all 0.3s;
  }
  i {
    font-size: 10px;
    &.desc {
      transform: rotate(180deg);
    }
  }
}
</style>
